import React, { Component } from "react";
import PropTypes from "prop-types";
import { convertStringToElements } from "@vds/html-parsers";
import styled from "styled-components";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";

import { setBreadcrumbList } from "common-components/BreadCrumbs/actions";
import { setA11yContent } from "../../NavigationHelper/actions";
import { fetchPageContent } from "../actions";
import { ENDPOINTS } from "utils/endpoints";
import { media } from "utils/style";
import { checkNestedObject } from "utils/checkNestedObject";
import { checkIfGuestFlow } from "utils/checkIfGuestFLow";
import { isAccountMember } from "utils/isAccountMember";
import { setBaseURLForNonSecure } from "../../../../../Services/API";
import { checkAMLob } from "utils/checkAMLob";
import { clearErrors, fetchProfileAPI, checkIfMDNisSMSCapable } from "../actions";
import { TitleLockup } from "@vds/type-lockups";
import { Body } from "@vds/typography";
import Modal from "common-components/Modal/Modal";
import CommonHeader from "common-components/Header";
import AlertBanner from "common-components/Alert";
import CommonContainer from "common-components/Container";
import Button from "common-components/Buttons";
import RectangleLoader from "common-components/RectangleLoader/RectangleLoader";
import DeleteReview from "./DeleteReview";
import DeleteHumModal from "./DeleteHumModal"

class DeleteInformation extends Component {
  state = {
    loading: true,
    loadingMFACalls: false,
    isGuestFLow: false,
    isWireline: false,
    visibleModal: false,
    humModal: false
  };

  componentDidMount() {
    const isGuestFLow = checkIfGuestFlow(this.props.location);
    const isWireline = checkAMLob() === "vzt";

    if (isGuestFLow) {
      this.setState({ isGuestFLow: true });
    }

    if (isWireline) {
      this.setState({ isWireline: true });
    }

    if (isWireline || (checkAMLob() === "vzw" && window.reactGlobals.isSingleLineAcct) || (!window.reactGlobals.isSingleLineAcct)) {
      if (checkNestedObject(this.props.pageContent, "breadCrumbs", "landingPage")) {
        const {
          breadCrumbs: { landingPage, deleteRequest }
        } = this.props.pageContent;

        this.props.setBreadcrumbList([
          { label: landingPage, path: "/privacy/secure/your-data" },
          {
            label: deleteRequest,
            path: "/privacy/secure/delete"
          }
        ]);
      }
    }

    let url = "";

    if (isGuestFLow) {
      setBaseURLForNonSecure();
      url = ENDPOINTS.FETCH_GUEST_DELETE_PAGE_NEW;
    } else if (isWireline) {
      url = ENDPOINTS.FETCH_WIRELINE_DELETE_PAGES;
    } else {
      url = ENDPOINTS.FETCH_DELETE_PAGES;
    }

    this.props.fetchPageContent(url).then(() => {
      this.setState({ loading: false });

      const { pageContent } = this.props;
      if (
        checkNestedObject(pageContent, "delete_information", "sc_pagetitle") ||
        checkNestedObject(pageContent, "delete_information_guest", "sc_pagetitle")
      ) {
        if (checkNestedObject(pageContent, "delete_information", "sc_pagetitle")) {
          this.props.setA11yContent("Delete information", pageContent.delete_information.sc_pagetitle);
        } else {
          this.props.setA11yContent("Delete information", pageContent.delete_information_guest.sc_pagetitle);
        }
      }
    });

    if (checkNestedObject(this.props, "location", "state", "visibleModal")) {
      this.setState({ visibleModal: true });
    }
  }

  componentWillUnmount() {
    this.props.clearErrors();
  }

  componentDidUpdate() {
    var reactThis = this;
    const el = document.getElementById('hum_button');
       if (el) {
        el.setAttribute('aria-label','More information about making your delete request');
      el.addEventListener("click", function () {
        reactThis.setState({
          humModal: true
        })
      });
    }
  }


  closeModal = () => {
    this.setState({
      humModal: false
    })
  }

  handleModalPopup = () => {
    this.setState({ visibleModal: false });
    this.props.location.state = {};
  };

  handleContinueClick = () => {
    const { isEmailVerified, isMTNVerified } = window.reactGlobals;
    const route =
      checkAMLob() === "vzt" && (isEmailVerified === "N" && isMTNVerified === "N")
        ? "/privacy/secure/action-needed"
        : "/privacy/secure/multifactor-authentication-primer";

    /*
        22.16.1
        We dont want to show the line selection for multi account customers during delete flow.
    */

    let next = null;
    if (undefined !== window.reactGlobals.cpraFlagEnabled && "Y" === window.reactGlobals.cpraFlagEnabled) {
      next = () =>
        this.props.history.replace(route, {
          confirmAuth: true,
          hideChangeDeviceButton: true,
          visibleModal: true,
          nextRoute: "/privacy/secure/delete"
        });
    }
    else {
      next = () =>
        this.props.history.replace(route, {
          confirmAuth: true,
          hideChangeDeviceButton: true,
          visibleModal: true,
          nextRoute:
            isAccountMember() || window.reactGlobals.isSingleLineAcct || this.state.isWireline
              ? "/privacy/secure/delete"
              : "/privacy/secure/delete-line-selection"
        });
    }


    if (checkAMLob() === "vzw") {
      this.setState({ loadingMFACalls: true });
      this.props.fetchProfileAPI().then(() => {
        if (!this.props.error) {
          const { loggedInMdn } = window.reactGlobals;
          const { deviceList } = this.props;
          const mfaMdn = deviceList.find(device => device.mtn === loggedInMdn);

          if(window.reactGlobals.isAllMdnDisconnected){
            const selectedDevice = deviceList[0]
            this.props
            .checkIfMDNisSMSCapable(selectedDevice && selectedDevice.encryptedMtn ? selectedDevice.encryptedMtn : "")
            .then(() => {
              const { mfaAllowed } = this.props.verifiedSecurePinDevice;
              this.setState({ loadingMFACalls: false });

              if (!this.props.error) {
                if (mfaAllowed === false) {
                  this.props.history.push("/privacy/secure/action-needed");
                } else {
                  next();
                }
              }
            });
          } else{
          this.props
            .checkIfMDNisSMSCapable(mfaMdn && mfaMdn.encryptedMtn ? mfaMdn.encryptedMtn : "")
            .then(() => {
              const { mfaAllowed } = this.props.verifiedSecurePinDevice;
              this.setState({ loadingMFACalls: false });

              if (!this.props.error) {
                if (mfaAllowed === false) {
                  this.props.history.push("/privacy/secure/action-needed");
                } else {
                  next();
                }
              }
            });
          }
        } else {
          this.setState({ loadingMFACalls: false });
        }
      });
    } else {
      next();
    }
  };

  renderContinueButton = ({ text, type }) => {
    if (this.state.isGuestFLow) {
      return (
        <Button
          background={type}
          role="link"
          onClick={() => this.setState({ visibleModal: true })}
        //  onClick={() => this.props.history.push("/privacy/your-data/guest/review")}
        >
          {text}
        </Button>
      );
    }
    return (
      <Button background={type} onClick={this.handleContinueClick}>
        {text}
      </Button>
    );
    // if (isAccountMember() || window.reactGlobals.isSingleLineAcct || this.state.isWireline) {
    //   return (
    //     // <Button background={type} onClick={() => this.setState({ visibleModal: true })}>
    //     <Button
    //       background={type}
    //       onClick={() =>
    //         this.props.history.replace({
    //           pathname: "/privacy/secure/multifactor-authentication-primer",
    //           state: {
    //             confirmAuth: true,
    //             visibleModal: true,
    //             nextRoute: "/privacy/secure/delete"
    //           }
    //         })
    //       }
    //     >
    //       {text}
    //     </Button>
    //   );
    // }
    // return (
    //   <Button
    //     background={type}
    //     onClick={() =>
    //       this.props.history.push({
    //         pathname: "/privacy/secure/delete-line-selection",
    //         state: { confirmAuth: true }
    //       })
    //     }
    //   >
    //     {text}
    //   </Button>
    // );
  };

  render() {
    if (this.state.loading) {
      return <RectangleLoader id={"deleteLoader"} style={{ padding: "0 16px" }} />;
    }

    const { isGuestFLow } = this.state;
    let pageContent = {};

    if (isGuestFLow) {
      ({
        pageContent: { delete_information_guest: pageContent }
      } = this.props);
    } else {
      ({
        pageContent: { delete_information: pageContent }
      } = this.props);
    }

    const { hasDeleted, deleteRequestType } = this.props;


    if (
      (hasDeleted === "Y" && checkAMLob() !== "vzw") ||
      (hasDeleted === "Y" &&
        !isGuestFLow &&
        (deleteRequestType === "all" ||
          (deleteRequestType === "self" && window.reactGlobals.isSingleLineAcct)))
    ) {
      return (
        <Redirect to={{ pathname: "/privacy/secure/delete-request-success", state: { confirmAuth: true } }} />
      );
    }
    return (
      <div style={{ display: "relative" }}>
        {this.state.loadingMFACalls && (
          <RectangleLoader
            style={{
              position: "absolute",
              top: "0",
              right: "0",
              bottom: "0",
              left: "0",
              background: "white",
              zIndex: "999999",
              margin: "0",
              animation: "0"
            }}
          />
        )}
        {this.props.error ? (
          <AlertBanner alertType="error" disableAnimation>
            {this.props.error}
          </AlertBanner>
        ) : null}
        <Container noTabletPadding>

          <div style={{ maxWidth: "596px" }}>
          <TitleLockup
            data={{
              title: {
                size: 'titleXLarge',
                bold: false,
                children: pageContent.section_title  
              },
              subtitle : {
                size: 'titleMedium',
                children: <Div>
                  { isGuestFLow ?
                    convertStringToElements(pageContent.section_description) : null
                  }
                  { pageContent.icontexts.map(item =>
                  (checkAMLob() === "vzw" && item.role[window.reactGlobals.customRole] === "true") ||
                  checkAMLob() !== "vzw" ?  
                  <Div key={item.text}>
                    { item && item.headingText ?
                      convertStringToElements(item.headingText)
                      : null }
                      {convertStringToElements(item.text)}
                  </Div> 
                  : null
                  )
                  }
                  </Div>
                }                  
            }}
          />
          </div>
          <ButtonContainer>
            {this.renderContinueButton(pageContent.buttons[0])}
            <Button
              role="link"
              background={pageContent.buttons[1].type}
              onClick={() => this.props.history.goBack()}
            >
              {pageContent.buttons[1].text}
            </Button>
          </ButtonContainer>
        </Container>
        <Modal id="modalStyle" visibleModal={this.state.visibleModal} closeModal={this.handleModalPopup}>
          <DeleteReview closeModal={this.handleModalPopup} />
        </Modal>
        {this.state.humModal ? <DeleteHumModal modalContent={this.props.pageContent.hum_modal} closeModal={() => this.closeModal()} /> : null}
      </div>
    );
  }
}

const mapStateToProps = ({
  modalState: { showModal },
  downloadAndDelete: { hasDeleted, deleteRequestType },
  loadingAndErrorState: { loading, error },
  pageContent,
  deleteLineSelection,
  verifiedSecurePinDevice,
  profileInformation: deviceList
}) => ({
  showModal,
  loading,
  error,
  hasDeleted,
  deleteRequestType,
  pageContent,
  deleteLineSelection,
  deviceList,
  verifiedSecurePinDevice
});

export default connect(
  mapStateToProps,
  {
    setA11yContent,
    fetchPageContent,
    setBreadcrumbList,
    clearErrors,
    fetchProfileAPI,
    checkIfMDNisSMSCapable
  }
)(DeleteInformation);

DeleteInformation.propTypes = {
  setA11yContent: PropTypes.func.isRequired,
  showModal: PropTypes.bool,
  fetchPageContent: PropTypes.func.isRequired,
  pageContent: PropTypes.oneOfType([PropTypes.array, PropTypes.object])
};

const Container = styled(CommonContainer)`
margin: 0px 0px 0px 20px;
padding: 64px 20px ;

  ${media.tablet`
    max-width: 80%;
  `}

  ${media.mobile`
    margin: 0;
    padding: 32px 16px ;
  `}
`;

const Div = styled.div`
  margin: 32px 0;

  p {
  margin: 12px 0;
  font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; 
  letter-spacing: 0.5px
  }

  p strong {
 font-size: 24px;
 font-style: normal;
 font-weight: 700;
 line-height: 28px;
  }
  
  #hum_button  {
    text-decoration: underline;
    border: transparent;
    background-color: transparent;
    padding: 0;
    cursor: pointer;
    }
  #hum_button:focus, #hum_button.focus {
    outline:2px solid #000000;
     }

  }

  ul {
    list-style: disc inside;
    margin: 15px 0;
  }
  li{
    font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
  }
`;

const HeaderDesc = styled.p`
font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
font-size: 48px;
font-style: normal;
font-weight: 400;
line-height: 48px;

  ${media.mobile`
    font-size: 16px;
    line-height: 20px;
  `}
`;

const ButtonContainer = styled.div`
  margin-top: 60px;
  display: flex;
  button,
  a {
    width: 172px;
  }
  ${media.mobile`
    flex-direction: column;    
  `}
`;

const Header = styled(CommonHeader)`
  max-width: 598px;
  font-size: 48px;
  line-height: 48px;
  margin-bottom: 24px;
  font-family:'Verizon NHG DS', Helvetica, Arial, sans-serif;
  font-weight: 300;

${media.mobile`
  font-size: 32px;	
  line-height: 36px;
  font-weight: 300;
  font-family:'Verizon NHG DS', Helvetica, Arial, sans-serif;
`}
`;
